import { Card, CardContent, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { FunctionComponent, useMemo } from 'react';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useDjRequestedUsersQuery } from '../../event/hooks/useDjRequestedUsersQuery';
import { Layout } from '../../navigation/components/Layout/Layout';

interface DjRequestRow {
  id: string;
  firstname?: string | null;
  lastname?: string | null;
  nickname?: string | null;
  studyTown?: string | null;
  studies?: string | null;
  djStyle?: string | null;
  djTime?: string | null;
}

export const AdminDjRequests: FunctionComponent = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const eventId = currentEventData?.currentEvent?.id ?? null;

  const { data, loading } = useDjRequestedUsersQuery(eventId);

  const rows = useMemo<DjRequestRow[]>(() => {
    return (data?.eventUsers ?? []).filter((user) => user.hasRequestedDj);
  }, [data]);

  const columns: GridColDef<DjRequestRow>[] = [
    { field: 'firstname', headerName: 'Prénom' },
    { field: 'lastname', headerName: 'Nom' },
    { field: 'nickname', headerName: 'Surnom' },
    { field: 'studies', headerName: 'Études' },
    { field: 'studyTown', headerName: 'Ville' },
    { field: 'djStyle', headerName: 'Style' },
    { field: 'djTime', headerName: 'Créneau' },
  ];

  return (
    <Layout title="Administration - Demandes DJ" activeTab="adminDjRequests">
      {rows.length === 0 && !loading ? (
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Typography>Aucune demande DJ pour le moment.</Typography>
          </CardContent>
        </Card>
      ) : null}
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        loading={loading}
      />
    </Layout>
  );
};
